import {VoucherCodeQuery} from '@/ts/types/component/sign-up-type';
import partnerMediaAllianz from '@/assets/img/partner-media-allianz.webp';
import partnerMediaUsc from '@/assets/img/partner-media-usc.webp';

/** Assets, colors and i18n keys that make up a partner's sign-up branding */
export interface PartnerBranding {
  media: string;
  overlayColor: string;
  captionKey: string;
  titleKey: string;
  logoAsset: string;
  panelLogoClass: string;
}

/**
 * Visual branding per partner: photo, overlay color (brand blue for Allianz,
 * neutral dark for USC), caption and logo. USC's caption carries the full
 * partner name because its logo is a monogram; Allianz's logo is the wordmark
 * itself. ZIM deliberately has no branding.
 */
export const PARTNER_BRANDING: Partial<Record<VoucherCodeQuery, PartnerBranding>> = {
  [VoucherCodeQuery.ALLIANZ]: {
    media: partnerMediaAllianz,
    overlayColor: '#003781',
    captionKey: 'in_partnership_with',
    titleKey: 'partnership_allianz',
    logoAsset: 'partner-logo-allianz.svg',
    panelLogoClass: 'partner-logo--allianz',
  },
  [VoucherCodeQuery.URBAN_SPORTS_CLUB]: {
    media: partnerMediaUsc,
    overlayColor: '#20282E',
    captionKey: 'partnership_usc',
    titleKey: 'partnership_usc',
    logoAsset: 'partner-logo-usc.svg',
    panelLogoClass: 'partner-logo--usc',
  },
};
